// extracted by mini-css-extract-plugin
export var downArrow = "_7i-0";
export var label = "_7i-1";
export var treatmentCard = "_7i-3";
export var upArrow = "_7i-2";